import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import Dashboard from './components/Dashboard/Dashboard';
import OAuthLogin from './components/Auth/OAuthLogin';
import OAuthCallback from './components/Auth/OAuthCallback';
import Navigation from './components/Layout/Navigation';
import Footer from './components/Layout/Footer';
import Settings from './components/Settings/Settings';
import { amplifyConfig } from './config/amplify-config';

Amplify.configure(amplifyConfig);

function App({ signOut, user }) {
  return (
    <Router>
      <div className="app-container">
        <Navigation user={user} signOut={signOut} />
        
        <main className="app-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/auth/mmf-connect" element={<OAuthLogin />} />
            <Route path="/auth/callback" element={<OAuthCallback />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

// export default withAuthenticator(App, {
//   includeGreetings: false,
//   hideSignUp: process.env.REACT_APP_HIDE_SIGNUP === 'true',
// });

export default withAuthenticator(App, {
    // Configuration for authentication UI
    signUpAttributes: ['email'],
    socialProviders: [],
    variation: 'default',
  });